<template>
  <dv-full-screen-container>
    <div class="xm-ydk">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div class="xm-header">
        <div class="xm-header-time">
          <div class="xm-header-time__after"></div>
          <span class="xm-header-time__text">
            <dv-decoration-7 style="height: 30px">{{
              timeText
            }}</dv-decoration-7></span
          >
        </div>
        <dv-decoration-10
          style="width: 33.33%; height: 10px; margin-top: 20px"
        />
        <div class="xm-header__left">
          <dv-decoration-3 style="width: 100%; height: 30px" />
        </div>
        <dv-decoration-8
          :color="['#568aea', '#000000']"
          style="width: 10%; height: 50px; margin-top: 25px"
        />
        <div class="xm-header__title">
          <dv-decoration-5
            :dur="2"
            :color="['#568aea', '#568aea']"
            style="width: 100%; height: 30px"
          /><span>异地库可视化平台</span>
          <dv-decoration-6
            :reverse="true"
            :color="['#50e3c2', '#67a1e5']"
            style="width: 250px; height: 10px"
          />
        </div>
        <dv-decoration-8
          :reverse="true"
          :color="['#568aea', '#000000']"
          style="width: 10%; height: 50px; margin-top: 20px"
        />
        <dv-decoration-10
          style="
            width: 33.33%;
            height: 10px;
            margin-top: 15px;
            transform: rotateY(180deg);
          "
        />
        <div class="xm-header__btn">
          <el-button @click="showMenu">显示菜单</el-button>
        </div>
      </div>
      <div class="xm-content">
        <div class="xm-content-top">
          <div class="xm-content-top-box2">
            <div
              class="xm-store-row"
              v-for="(item, index) in storeData"
              :key="`row${index}`"
            >
              <div
                class="xm-store-item"
                v-for="(it, ix) in item"
                :key="`item${ix}`"
              >
                <dv-border-box-8>
                  <div class="xm-store-item-content">
                    <div
                      class="xm-store-item-content__title"
                      @click="handleToStore(it)"
                    >
                      <span>{{ it.title }}</span>
                    </div>
                    <div class="xm-store-item-content__category">
                      <span>分类</span>
                      <span>{{ it.category }}</span>
                    </div>
                    <div class="xm-store-item-content__total">
                      <span>总量</span>
                      <span>{{ it.data }}吨</span>
                    </div>
                  </div>
                </dv-border-box-8>
              </div>
            </div>
          </div>
          <div>
            <dv-border-box-7>
              <china></china>
            </dv-border-box-7>
          </div>
          <dv-border-box-3>
            <system-pie :chartData="systemData"></system-pie>
          </dv-border-box-3>
        </div>
        <div class="xm-content-bottom">
          <dv-border-box-10>
            <top-table title="预警" :tableData="warningData"></top-table>
          </dv-border-box-10>
          <dv-border-box-1>
            <in-out-chart :chartData="inOutData"></in-out-chart>
          </dv-border-box-1>
        </div>
      </div>
    </div>
  </dv-full-screen-container>
</template>

<script>
import { mapActions } from 'vuex'
import SystemPie from './components/systemPie'
import InOutChart from './components/inOutChart'
import TopTable from './components/topTable'
import China from './components/china'
import watermark from '@/common/watermark'

// const SYSTEM_TYPE = ['成品油', '碳材料', '化工品', '聚烯烃', '沥青']
const YDK_NAME = { LFDK: '利丰达库区', FLK: '丰利库区' }
export default {
  name: 'ydkBoard',
  components: {
    SystemPie,
    InOutChart,
    TopTable,
    China
  },
  data () {
    return {
      loading: true,
      timeText: '', // 时间
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      systemData: [],
      storeData: [],
      // storeData: [
      //   [
      //     { title: '利丰达库区', category: '成品油1', data: 10000 },
      //     { title: '丰利库区', category: '成品油2', data: 10000 },
      //     { title: '模拟库区1', category: '成品油3', data: 10000 }
      //   ],
      //   [
      //     { title: '模拟库区2', category: '成品油4', data: 10000 },
      //     { title: '模拟库区3', category: '成品油5', data: 10000 },
      //     { title: '模拟库区4', category: '成品油6', data: 10000 }
      //   ],
      //   [
      //     { title: '模拟库区5', category: '成品油7', data: 10000 },
      //     { title: '模拟库区6', category: '成品油8', data: 10000 },
      //     { title: '模拟库区7', category: '成品油9', data: 10000 }
      //   ],
      //   [
      //     { title: '模拟库区5', category: '成品油7', data: 10000 },
      //     { title: '模拟库区6', category: '成品油8', data: 10000 },
      //     { title: '模拟库区7', category: '成品油9', data: 10000 }
      //   ]
      // ],
      inOutData: {
        xAxisData: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        monthTotal: new Array(12).fill(0),
        inQuantity: new Array(12).fill(0),
        outQuantity: new Array(12).fill(0)
      },
      warningData: []
    }
  },
  created () {},
  mounted () {
    this.init()
  },
  beforeDestroy () {
    watermark.show()
  },
  methods: {
    ...mapActions(['queryYDKBoardData']),
    timeFn () {
      // 获取时间
      setInterval(() => {
        const now = new Date()
        this.timeText = `${now.toLocaleString()} ${this.weekday[now.getDay()]}`
      }, 1000)
    },
    async init () {
      this.loading = true
      try {
        this.timeFn()
        watermark.out()
        const result = await this.queryYDKBoardData()
        const { data } = result
        if (data) {
          const { itemTypeSumMap, monthInventoryNumList, monthNumList, forewarningList } = data
          // 体系图表及库区最高库存
          if (itemTypeSumMap) {
            const storeArr = []
            const systemArr = []
            Object.keys(itemTypeSumMap).forEach((key) => {
              const storeObj = {
                title: YDK_NAME[key],
                category: '',
                data: 0
              }
              // const seriesData = new Array(5).fill(0)
              if (
                Array.isArray(itemTypeSumMap[key]) &&
                itemTypeSumMap[key].length > 0
              ) {
                itemTypeSumMap[key].forEach((item) => {
                  const { itemType, quantity } = item
                  const curr = systemArr.find(it => it.name === itemType)
                  if (curr) {
                    curr.value += quantity
                  } else {
                    systemArr.push({ name: itemType, value: quantity })
                  }
                  // const idx = SYSTEM_TYPE.indexOf(itemType)
                  // if (idx > -1) {
                  //   seriesData[idx] = quantity
                  // }
                  if (quantity > storeObj.data) {
                    storeObj.data = quantity
                    storeObj.category = itemType
                  }
                })
              }
              // const seriesObj = {
              //   name: YDK_NAME[key],
              //   type: 'bar',
              //   stack: 'total',
              //   label: {
              //     show: true,
              //     formatter: (config) => {
              //       const { seriesName, value } = config
              //       return value ? `${seriesName}:${value}` : ''
              //     }
              //   },
              //   emphasis: {
              //     focus: 'series'
              //   },
              //   data: seriesData
              // }
              storeArr.push(storeObj)
              // this.systemData.push(seriesObj)
            })
            this.convertStoreData(storeArr)
            this.systemData = systemArr
          }
          // 出入库图表数据
          if (
            Array.isArray(monthInventoryNumList) &&
            monthInventoryNumList.length > 0 &&
            Array.isArray(monthNumList) &&
            monthNumList.length > 0
          ) {
            monthInventoryNumList.forEach((item) => {
              const { month, quantity } = item
              this.inOutData.monthTotal.splice(month - 1, 1, quantity)
            })
            monthNumList.forEach((item) => {
              const { month, inQuantity, outQuantity } = item
              this.inOutData.inQuantity.splice(month - 1, 1, inQuantity)
              this.inOutData.outQuantity.splice(month - 1, 1, outQuantity)
            })
          }
          this.warningData = forewarningList
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    handleToStore ({ title }) {
      if (title.includes('利丰达')) {
        this.$router.push({ path: '/lfdBoard' })
      }
    },
    convertStoreData (data) {
      let storeArr = []
      for (let i = 0; i < data.length; i += 3) {
        storeArr.push(data.slice(i, i + 3))
      }
      this.storeData = storeArr
    },
    showMenu () {
      this.$router.replace({ path: '/virtual/ydkBoard' })
    }
  }
}
</script>

<style scoped lang="scss">
.xm-ydk {
  width: 100%;
  height: 100%;
  background: url('~@/assets/imgs/ydk/bg.png') no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  ::v-deep .loading-tip {
    font-size: 23px !important;
    color: aqua;
    font-weight: bold;
  }
  .xm-header {
    width: 100%;
    height: 6%;
    display: flex;
    position: relative;
    .xm-header__left {
      position: absolute;
      left: 7%;
      top: 32px;
    }
    .xm-header__btn {
      position: absolute;
      right: 2%;
      top: 28px;
    }
    .xm-header-time {
      position: absolute;
      right: 7%;
      top: 36%;
      color: #06f1ef;
      font-size: 20px;
      background-color: rgb(15, 19, 37);
      width: 20.33%;
      height: 50px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      -webkit-transform: skewX(-45deg);
      transform: skewX(-45deg);
      .xm-header-time__text {
        display: inline-block;
        transform: skewX(45deg);
      }
      .xm-header-time__after {
        position: absolute;
        right: -25px;
        top: 0;
        height: 50px;
        width: 50px;
        background-color: rgb(15, 19, 37);
        -webkit-transform: skewX(45deg);
        transform: skewX(45deg);
      }
    }
    .xm-header__title {
      width: 500px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      font-size: 25px;
      color: white;
    }
  }
  .xm-content {
    width: 100%;
    height: 94%;
    .xm-content-top {
      height: 50%;
      padding: 10px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;

      .xm-content-top-box2 {
        width: 100%;
        height: 100%;
        overflow: auto;

        /* 隐藏默认的滚动条样式 */
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */

        .xm-store-row {
          height: 33.33%;
          display: flex;
          .xm-store-item {
            text-align: center;
            font-size: 18px;
            color: #06f1ef;
            // width: 250px;
            // height: 134px;
            width: 33.33%;
            .xm-store-item-content {
              display: flex;
              flex-direction: column;
              height: 100%;
              justify-content: space-evenly;
              .xm-store-item-content__title,
              .xm-store-item-content__category,
              .xm-store-item-content__total {
                flex: 1;
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                height: 30px;
                line-height: 30px;
              }
              .xm-store-item-content__category,
              .xm-store-item-content__total {
                span:first-child {
                  flex: 1;
                }
                span:nth-child(2) {
                  flex: 2;
                }
              }
              .xm-store-item-content__title {
                cursor: pointer;
              }
            }
            .xm-store-item-content__title:hover {
              font-weight: bold;
              font-size: 20px;
            }
          }
        }
      }

      .xm-content-top-box2::-webkit-scrollbar {
        display: none; /* Chrome, Safari, and Opera */
      }
    }
    .xm-content-bottom {
      height: 50%;
      padding: 10px;
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
